export const required = value =>
  value ? undefined : "Поле обязательное для заполнения";
